import { render, staticRenderFns } from "./CanCancelSale.vue?vue&type=template&id=545cab8a&scoped=true"
import script from "./CanCancelSale.vue?vue&type=script&lang=js"
export * from "./CanCancelSale.vue?vue&type=script&lang=js"
import style0 from "./CanCancelSale.vue?vue&type=style&index=0&id=545cab8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cab8a",
  null
  
)

export default component.exports